import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IProductListDesignWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProductListDesignWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BProductListSecondPage: any[];
  B2BProductListSecondPage_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  SetFocusTo: any;
  SetFocusTo_dummy: any;
  B2BAddFavoritesPattern: number;
  B2BAddFavoritesPattern_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  B2BRemoveFavoritesPattern: number;
  B2BRemoveFavoritesPattern_dummy: number;
  isComp624375Visible: "visible" | "hidden";
  isComp848426Visible: "visible" | "hidden";
}

export class ProductListDesignWeb_ScreenBase extends React.PureComponent<
  IProductListDesignWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  productlistdesignweb_677340_value_kuikaGalleryViewRef: React.RefObject<any>;
  productlistdesignweb_931944_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 310394,
          PropertyName: "value",
          Value: "Desen",
          TagName: "Label4_value",
        },
        {
          Id: 125020,
          PropertyName: "value",
          Value: "Koleksiyon Adı:",
          TagName: "Label12_value",
        },
        {
          Id: 313063,
          PropertyName: "placeholder",
          Value: "Desen Ara",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 310394,
          PropertyName: "value",
          Value: "Pattern",
          TagName: "Label4_value",
        },
        {
          Id: 125020,
          PropertyName: "value",
          Value: "Collection Name:",
          TagName: "Label12_value",
        },
        {
          Id: 313063,
          PropertyName: "placeholder",
          Value: "Search for Pattern",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "092cd24c-c763-4c30-946f-d102710f779c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 310394, PropertyName: "value", Value: "Desen" },
        { Id: 125020, PropertyName: "value", Value: "Koleksiyon Adı:" },
        { Id: 313063, PropertyName: "placeholder", Value: "Desen Ara" },
        {
          Id: 677340,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.productlistdesignweb_313063_value_kuikaTextInputRef =
      React.createRef();
    this.productlistdesignweb_677340_value_kuikaGalleryViewRef =
      React.createRef();
    this.productlistdesignweb_931944_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetUserId: [],
      B2BProductListSecondPage: [],
      NAVIGATE: "",
      SetValueOf: "",
      SetFocusTo: "",
      B2BAddFavoritesPattern: 0,
      TriggerEvent: "",
      B2BRemoveFavoritesPattern: 0,
      isComp624375Visible: "hidden",
      isComp848426Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "productlistdesignweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProductListDesignWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ProductListDesignWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "productlistdesignweb",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "productlistdesignweb",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProductListDesignWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProductListDesignWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ProductListDesignWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_931944_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_1: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListDesignWeb/ProductListDesignWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BProductListSecondPage = result?.data.b2BProductListSecondPage;

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProductListDesignWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListDesignWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_677340 =
      stateVars.B2BProductListSecondPage ?? this.state.B2BProductListSecondPage;
    stateVars.isComp624375Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "isFavorite"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848426Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "isFavorite"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.productlistdesignweb_931944_total = ReactSystemFunctions.value(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].totalRowCount
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProductListDesignWebComponent_115807_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_376848_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productlistcollectionwebscreen") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductListDesignWeb",
      "ProductListCollectionWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_770837_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_313063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListDesignWeb/ProductListDesignWebComponent_770837_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BProductListSecondPage = result?.data.b2BProductListSecondPage;

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListDesignWebComponent_770837_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListDesignWebComponent_770837_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_313063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ""
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "productlistdesignweb_931944_value",
          "string"
        ),
        1,
        ReactSystemFunctions.convertToTypeByName("current", "string"),
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListDesignWebComponent_770837_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListDesignWebComponent_770837_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductListDesignWebComponent_770837_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_313063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ""
      )
    ) {
      stateVars.SetFocusTo = await ReactSystemFunctions.setFocusTo(
        ReactSystemFunctions.convertToTypeByName("313063", "string")
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListDesignWebComponent_770837_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.ProductListDesignWebComponent_770837_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  ProductListDesignWebComponent_770837_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_677340 =
      stateVars.B2BProductListSecondPage ?? this.state.B2BProductListSecondPage;
    formVars.productlistdesignweb_931944_total = ReactSystemFunctions.value(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].totalRowCount
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_425192_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/productfourthweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ProductFourthWeb",
      "ProductAttribute02",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute02"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "ProductFourthWeb",
      "ProductAttribute03",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute03"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "ProductFourthWeb",
      "ColorCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "colorCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "ProductListDesignWeb",
      "ProductFourthWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_624375_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute02"
        ),
        "string"
      ),
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute03"
        ),
        "string"
      ),
      ProductAttribute02Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute02Description"
        ),
        "string"
      ),
      ProductAttribute03Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute03Description"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListDesignWeb/ProductListDesignWebComponent_624375_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BAddFavoritesPattern = result?.data.b2BAddFavoritesPattern;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListDesignWebComponent_624375_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListDesignWebComponent_624375_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductListDesignWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_848426_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute02"
        ),
        "string"
      ),
      ProductAttribute02Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute02Description"
        ),
        "string"
      ),
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute03"
        ),
        "string"
      ),
      ProductAttribute03Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "productlistdesignweb_677340_value",
          "productAttribute03Description"
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListDesignWeb/ProductListDesignWebComponent_848426_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BRemoveFavoritesPattern =
      result?.data.b2BRemoveFavoritesPattern;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListDesignWebComponent_848426_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListDesignWebComponent_848426_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.ProductListDesignWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProductListDesignWebComponent_931944_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_931944_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "productlistdesignweb_313063_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ProductListDesignWeb/ProductListDesignWebComponent_931944_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BProductListSecondPage = result?.data.b2BProductListSecondPage;

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ProductListDesignWebComponent_931944_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProductListDesignWebComponent_931944_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.productlistdesignweb_376848_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_677340 =
      stateVars.B2BProductListSecondPage ?? this.state.B2BProductListSecondPage;
    formVars.productlistdesignweb_931944_total = ReactSystemFunctions.value(
      this,
      stateVars.B2BProductListSecondPage !== undefined
        ? stateVars.B2BProductListSecondPage?.length > 0
          ? stateVars.B2BProductListSecondPage[0].totalRowCount
          : null
        : this.state.B2BProductListSecondPage?.length > 0
        ? this.state.B2BProductListSecondPage[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProductListDesignWebPageInit();
    }
  }
}
